import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_offsite_housing_sites_occupied_by_wrkrs_managed_or_contr'

export const dataPointDefinition = {
  retracedId: 'num_of_offsite_housing_sites_occupied_by_wrkrs_managed_or_contr',
  name: 'Number of off-site housing sites occupied by workers managed or controlled by the facility:',
  description:
    'Off-site housing means any type of accommodation including dormitory and other residential building, flat, apartment, or room. \r\r\nOnly include accommodation that is managed directly by the facility/employer, or for which the facility/employer is contractually responsible for the conditions. E.g., the facility has authority to make or can directly influence housing related decisions, including direct involvement in the day-to-day  management of the dormitory conditions and provisions.\r\r\nOnly include accommodation that houses workers. Accommodation does not have to ONLY include workers to be included in this count. As long as one worker is housed in the accommodation, include that accommodation in this count. \r\r\n\r\r\nIf the facility does not have off-site housing occupied by workers that is managed or controlled by the facility, enter number "0".\r\r\n\r\r\nAttach documentation (e.g., a map) showing a) location of off-site dormitory managed/ controlled by facility; b) name of dormitory, if applicable; d) number of workers living in the dormitory; e) name of company managing dormitory operations, if facility is not the manager. \r\r\n\r\r\nWorkers are persons working on/with the facility\'s product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them. Facilities include those involved in production of goods, and also those involved in operations related to the product, e.g. distribution. Examples of "workers" are cutters, sewers, QC, packers, etc. (all workers who contribute to produce the product), boiler workers, mechanics (machine repair persons), and workers who load product onto trucks.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bui-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 810,
  sectionId: '2.2.9.10',
  impactArea: 'Accommodation & Dormitories',
  impactAreaId: 'ACCOMODATION_AND_DORMITORIES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
